import { Routes, Route, Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { hasAdminAccess, isClubOwner } from "../../../utils/roles";
import AdminOwnerMemberProfile from "./AdminOwnerMemberProfile";
import AdminOwnerProfileAccount from "./AdminOwnerProfileAccount";

/**
 * Профиль в админке: владелец — полный (с подпиской CRM),
 * администратор — тот же портал без биллинга платформы.
 */
export default function AdminOwnerProfile() {
  const { role, profile, club } = useSelector((state) => state.auth);
  const owner = isClubOwner({ role, profileRole: profile?.role, club });

  if (!hasAdminAccess(role)) {
    return <Navigate to="/manage/app/more" replace />;
  }

  return (
    <Routes>
      <Route index element={<AdminOwnerMemberProfile />} />
      <Route
        path="account/*"
        element={<AdminOwnerProfileAccount showBilling={owner} />}
      />
      <Route
        path="settings"
        element={<Navigate to="/manage/app/profile/account" replace />}
      />
      <Route path="*" element={<Navigate to="/manage/app/profile" replace />} />
    </Routes>
  );
}
